import styled, { css } from 'styled-components';

export const ContentElement = styled.div`
  ${({ theme }) => {
    return css`
      background-color: ${theme.color.dark};
      color: ${theme.color.white};
      font-size: ${theme.typography.font_size.text_xs};
      padding: ${theme.spacing.xs} ${theme.spacing.sm};
      border-radius: ${theme.radius.xs};
      box-sizing: border-box;
      width: max-content;
      max-width: calc(100vw - 1rem);
      position: relative;
      z-index: 5000;
    `;
  }};
`;
